import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SettingsService } from 'src/app/services/settings.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';

@Component({
    selector: 'app-branches',
    templateUrl: './branches.component.html',
    styleUrls: ['./branches.component.css'],
    standalone: false
})

export class BranchesComponent implements OnInit {

  addTemplateSidebar: boolean = false;
  userInfo: any = [];
  branchData: any = [];
  showPlaceholder: boolean = false;
  _templateTitle: string = '';
  saveBtnLoading: boolean = false;
  branchName: string = '';
  branchList: any;
  edit: boolean = false;
  clicked: boolean = false;
  userPrivileges: Set<string> = new Set();
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,24}$/;
  editIndex: any = -1;
  branchDetails: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    mobile_number: new FormControl('', [
      Validators.pattern('^[0-9]{10}$')
    ]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
    address_line_1: new FormControl('', Validators.required),
    address_line_2: new FormControl(),
    area: new FormControl(),
    city: new FormControl(),
    state: new FormControl(),
    postal_code: new FormControl()
  })
  gettingBranchDetails: boolean = false;
  gettingBranches: boolean = false;

  constructor(private settings: SettingsService, private messageService: MessageService,private globalService: GlobalServicesService,private sharedService: SharedServicesService) { }

  ngOnInit(): void {
    this.getBranch();
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    
  }
  getBranch() {
    this.gettingBranches = true;
    this.settings.getBranchDataFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.branchData = res.body;
          if(this.branchData?.length) {
            this.selectBranch(this.openedBranch() ? this.openedBranch() : this.branchData[0])
          }
        }
        this.gettingBranches = false;
      },
      error: (_err) => {
        this.gettingBranches = false;
      }
    });
  }

  editBranch(id: number, edit: boolean = true) {
    this.edit = edit;
    this.editIndex = id;
    this.addTemplateSidebar = true;
    this.gettingBranchDetails = true;
    this.settings.getSpecificBranchDataFastApi(id.toString()).subscribe({
      next: (res: any) => {
        this.branchDetails.patchValue(res.body);
        this.gettingBranchDetails = false;
      },
      error: (_err) => {
      this.gettingBranchDetails = false;
      }
    });
  }

  deleteBranch(id: number) {
    this.settings.deleteSpecificBranchDataFastApi(id.toString()).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
        this.openedBranch.set(null);
        this.getBranch();
      },
      error: (_err) => {
      }
    });
  }

  openAddTemplate() {
    this.edit = false;
    this.branchDetails.reset();
    this.addTemplateSidebar = true;
  }

  cancel = () => {
    this.branchDetails.reset();
    this.addTemplateSidebar = false;
  }

  saveTemplate = () => {
    if(!this.branchDetails.dirty) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'No Changes Detected', 
        detail: 'You haven\'t made any changes to the form. Please update at least one field before submitting.' 
      });
      return;
    }

    this.clicked = true;
    this.branchDetails.get('name')?.markAsTouched();
    this.branchDetails.get('address_line_1')?.markAsTouched();
    this.branchDetails.get('address_line_2')?.markAsTouched();
    this.branchDetails.get('area')?.markAsTouched();
    this.branchDetails.get('city')?.markAsTouched();
    this.branchDetails.get('state')?.markAsTouched();
    const fieldsToCheck = ['name', 'address_line_1', 'address_line_2', 'area', 'city', 'state'];
    if (this.sharedService.hasSecurityViolations(this.branchDetails, fieldsToCheck)) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.saveBtnLoading = false;
      return;
    }

    if (this.branchDetails.valid) {
      this.saveBtnLoading = true;
      let securePayload = this.sharedService.getSecurePayload(this.branchDetails.value);
      securePayload.email = securePayload.email.toLowerCase();
      
      const apiCall = this.edit ? this.settings.updateSpecificBranchDataFastApi(this.editIndex.toString(), securePayload)
                                : this.settings.createBranchDataFastApi(securePayload);
      apiCall.subscribe({
        next: (res: any) => {
          !this.edit && this.openedBranch.set(null);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
          this.getBranch();
          this.edit = false;
          this.addTemplateSidebar = false;
          this.clicked = false;
          this.branchDetails.reset();
          this.saveBtnLoading = false;
        },
        error: (err) => {
          console.error("Failed to save branch:", err);
          this.saveBtnLoading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please Fill the Required Fields' });
      this.saveBtnLoading = false;
    }
  }
  handleKeyDown(event: KeyboardEvent, id: number) {
    if (event.key === 'Enter') {
      this.editBranch(id);
    }
  }

  openedBranch: WritableSignal<any> = signal<any>(null)
  selectBranch(branch: any) {
    if(!branch) return;

    this.openedBranch.set(branch);
    this.editBranch(branch.id, true)
  }
}


